export * from './hall.component';
